import classNames from 'classnames';
import {TPropsWithClassName} from 'core/types';
import {HTMLProps, memo} from 'react';

interface IInfoWysiwygProps extends HTMLProps<HTMLDivElement> {
    content: string;
}

const InfoWysiwyg = memo<TPropsWithClassName<IInfoWysiwygProps>>(({content, className}) => (
    <div
        className={classNames(className, 'wysiwyg')}
        // eslint-disable-next-line @typescript-eslint/naming-convention
        dangerouslySetInnerHTML={{__html: content}}
        data-skeleton-item={true}
    />
));

export default InfoWysiwyg;
